/**
 * ArgumentNullException      NullException         400
 * ArgumentException          ValidationError       400
 * KeyNotFoundError           NotFoundError         404
 * OperationCanceledException NotProcessedOperation 403
 * Conflict                                         409
 * Ok                         CorrectOperation      200
 * Otras                      UnKnowError           500
 *                            OperationError        500
 */
import Router from '@/router';
import Utils from '@/components/shared/helpers/Utils.js';

export function handleError (err) {
  let errObject = {};
  let errorMessage = null;
  const response = err.response || {};
  const responseData = response.data || {};
  const responseError = responseData.error;

  if (responseError && responseError.errorMessage) {
    errorMessage = responseError.errorMessage;
  }

  if (!errorMessage && responseError) {
    const parsedError = Utils.isJson(responseError)
      ? typeof responseError === 'string' ? JSON.parse(responseError) : responseError
      : null;
    errorMessage = parsedError && parsedError.errorMessage
      ? parsedError.errorMessage
      : responseError;
  }

  errObject.status = response.status;
  errObject.message = errorMessage;

  return errObject;
};

export function handleRedirect (e) {
  const statusError = e.status ? e.status : null;
  if (!statusError) return;

  switch (statusError) {
    case 401:
    case 403:
      Router.push({ name: '401' });
      break;
    case 404:
      Router.push({ name: '404' });
      break;
    default:
      break;
  }
}
